var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuideOutline = function SvgGuideOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.418 16H6.875v-4h10.543l2 2zM4.582 6.625l2-2h10.543v4H6.582zm15.896 7.022-2.5-2.5a.5.5 0 0 0-.353-.147h-5.25V9.625h5.25a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5.25v-1a.5.5 0 1 0-1 0v1h-5a.5.5 0 0 0-.354.147l-2.5 2.5a.5.5 0 0 0 0 .707l2.5 2.5a.5.5 0 0 0 .354.146h5V11h-5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5v3.875h-2a.5.5 0 0 0 0 1h5a.5.5 0 1 0 0-1h-2V17h5.25a.5.5 0 0 0 .353-.146l2.5-2.5a.5.5 0 0 0 0-.707",
    clipRule: "evenodd"
  })));
};
export default SvgGuideOutline;